import { render, staticRenderFns } from "./FormProfileContatos.vue?vue&type=template&id=2916c749"
import script from "./FormProfileContatos.vue?vue&type=script&lang=js"
export * from "./FormProfileContatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports